// extracted by mini-css-extract-plugin
export var coll = "blog-coll-module--coll--1a4dc";
export var story_tileImg = "blog-coll-module--story_tile-img--219bb";
export var tiles = "blog-coll-module--tiles--1b7b0";
export var title = "blog-coll-module--title--8f6f3";
export var title_img = "blog-coll-module--title_img--bc753";